import React from 'react';
import { resolveBackendFileUrl } from '@utils/backendUrl';

interface Props {
  name?: string | null;
  email?: string | null;
  cohortTitle?: string | null;
  enrollmentNumber?: string | null;
  avatarPath?: string | null;
}

export const JourneyProfileHeader: React.FC<Props> = ({ name, email, cohortTitle, enrollmentNumber, avatarPath }) => {
  const avatar = avatarPath ? resolveBackendFileUrl(avatarPath) : null;
  return (
    <div className="sp-profilehead">
      <div className="sp-profilehead__avatar">
        {avatar ? <img src={avatar} alt="" /> : (name?.[0]?.toUpperCase() || 'S')}
      </div>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 18, fontWeight: 800 }}>{name || 'Student'}</div>
        <div className="sp-profilehead__meta">
          {email && <span>{email}</span>}
          {cohortTitle && <span>· {cohortTitle}</span>}
          {enrollmentNumber && <span>· {enrollmentNumber}</span>}
        </div>
      </div>
    </div>
  );
};
